import Vue from "vue";
import SearchButton from "@/components/SearchButton";

Vue.component(SearchButton.name, SearchButton);
